import { useState, useEffect, useCallback } from 'react';
import {
  Container,
  Stack,
  Typography,
  Select,
  MenuItem,
  Button,
  Grid,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  IconButton,
  Chip,
  Tooltip
} from '@mui/material';
import { Box } from '@mui/system';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import CustomDate from '../../components/CustomDate';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import photoDummy from './dummy/photoDummy.jpg';
import aadharFrontDummy from './dummy/aadharFrontDummy.jpg';
import aadharBackDummy from './dummy/aadharBackDummy.png';
import panCardDummy from './dummy/panCardDummy.jpg';
import cancelChequeDummy from './dummy/cancelChequeDummy.png';
import gstRegistrationCertificate from './dummy/GSTRegistrationCertificate.jpg';
import incorporationCertificate from './dummy/certificateIncorporation.jpg';
import logoDummy from './dummy/logoDummy.png';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import USERLIST from '../../_mocks_/user';
import {
  getCityData,
  getDocsTypesData,
  getPartnerCompanyType,
  getPartnerTypesData,
  getStateData,
  PreviewImageApi,
  saveApiData,
  setCityData
} from '../../store/Slice/Global/GlobalSlice';
import CustomSelect from '../../components/CustomSelect';
import CustomInput from '../../components/CustomInput';
import { OnboardingApi } from '../../utils/Apis';
import { setApiSuccess } from '../../store/Slice/Error/ErrorSlice';
import { isValidValue } from '../../utils/CommonFunction';
import PartnerHierarchyPage from './PartnerHierarchyComponent';
import { pillTabsSx } from '../Global/Styling';
import {
  getOnboardingView,
  getReportingManagerList
} from '../../store/Slice/Onboarding/OnboardingSlice';
import useOnboardingSelector from '../../store/Slice/Onboarding/OnboardingSelector';
import { savefileApiData } from '../../store/Slice/Payout/PayoutSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const validationSchema = yup.object().shape({
  mobile: yup
    .string()
    .required('Mobile number is required')
    .matches(/^[6-9][0-9]{9}$/, 'Enter a valid 10-digit mobile number'),
  emailAddress: yup.string().required('Email is required').email('Enter a valid email address'),
  partnerName: yup.string().required('Name is required'),
  dob: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .when('partnerType1', {
      is: 66,
      then: (schema) =>
        schema
          .required('Date of Birth is required')
          .test('age', 'Age should be greater than 18 years', (value) => {
            if (!value) return false;
            const birthDate = new Date(value);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            return age >= 18;
          }),
      otherwise: (schema) => schema.notRequired()
    })
});

function EditOnBoarding() {
  const [partnerType1, setPartnerType1] = useState('');
  const [photoPreview, setPhotoPreview] = useState(photoDummy);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(aadharFrontDummy);
  const [aadharBackPreview, setAadharBackPreview] = useState(aadharBackDummy);
  const [panPreview, setPanPreview] = useState(panCardDummy);
  const [chequePreview, setChequePreview] = useState(cancelChequeDummy);
  const [uploadPhoto, setUploadPhoto] = useState();
  const [uploadImageFileFront, setUploadImageFileFront] = useState(null);
  const [uploadImageFileBack, setUploadImageFileBack] = useState(null);
  const [uploadPanImage, setUploadPanImage] = useState();
  const [uploadChequeImage, setUploadChequeImage] = useState();
  const [gstImage, setGstImage] = useState();
  const [panPreview1, setPanPreview1] = useState(panCardDummy);
  const [gstPreview, setGstPreview] = useState(gstRegistrationCertificate);
  const [incorporationPreview, setIncorporationPreview] = useState(incorporationCertificate);
  const [incorporationUploadComp, setIncorporationUploadComp] = useState();
  const [uploadPanImageCompany, setUploadPanImageCompany] = useState();
  const [chequePreview1, setChequePreview1] = useState(cancelChequeDummy);
  const [uploadChequeCompany, setUploadChequeCompany] = useState();
  const [logoPreview, setLogoPreview] = useState(logoDummy);
  const [logoUpload, setLogoUpload] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [chequePreviewtype1, setChequePreviewtype1] = useState('');
  const [panPreviewtype1, setPanPreviewtype1] = useState('');
  const [aadharBackPreviewtype1, setAadharBackPreviewtype1] = useState('');
  const [photoPreviewtype1, setPhotoPreviewtype1] = useState('');
  const [aadharFrontPreviewtype1, setAadharFrontPreviewtype1] = useState('');
  const [chequePreview1type1, setChequePreview1type1] = useState('');
  const [panPreview1type1, setPanPreview1type1] = useState('');
  const [gstPreviewtype1, setGstPreviewtype1] = useState('');
  const [incorporationPreviewtype1, setIncorporationPreviewtype1] = useState('');
  const [logoPreviewtype1, setLogoPreviewtype1] = useState('');
  const [fileTypeId, setFileTypeId] = useState(0);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewFileType, setPreviewFileType] = useState('image');

  const { rowId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { rowId: rowData, parent } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const {
    stateDrop,
    CityDrop,
    DocsTypesDrop,
    PartnerStatusDrop,
    PartnerCompanyTypesDrop,
    AccessLevelConfig
  } = useGlobalSelector();
  const canEditPartner = AccessLevelConfig?.accessPagesMapping
    ?.find((accessPageMap) => accessPageMap?.pageCode === 'ONBOARDING_PAGE')
    ?.accessSubPagesMappings?.some(
      (pageElement) => pageElement?.subPageCode === 'ADD_NEW' && pageElement?.isEnable === true
    );
  const isEditBlocked = parent !== 'partner' && !canEditPartner;

  const handleChange = (event, newValue) => {
    setFileTypeId(newValue);
  };
  const { ReportingManagerListData } = useOnboardingSelector();
  const { OnboardingViewData: reviewData } = useOnboardingSelector();

  const {
    handleSubmit: handleReduxSubmit,
    control,
    setValue,
    reset,
    watch,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      partnerName: '',
      dob: '',
      emailAddress: '',
      mobile: '',
      misMonth: '',
      isNextUserAllowed: false,
      isPartnerLoginAllowed: false,
      isGSTEnable: false,
      gstNumber: ''
    }
  });

  const stateSelected = watch('provinceId') || null;
  const cityId = watch('districtId');
  const relationshipManager = watch('relationshipManager');
  const isGSTEnable = watch('isGSTEnable');

  const handleFileUpload = async (
    e,
    setPreview,
    setUploadImage,
    setLocaltype,
    typeCode,
    fieldName
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isPdf = file.type === 'application/pdf';

    setLocaltype(isPdf ? 'pdf' : 'image');
    setUploadImage(file);

    const blobUrl = URL.createObjectURL(file);
    setPreview(blobUrl);

    await uploadDocumentInstant(file, typeCode, fieldName);
  };

  const onDocumentLoadSuccess = useCallback(({ numPages }) => {
    setPageNumber(1);
  }, []);

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e, setPreview, setUploadImage, setLocaltype, typeCode, fieldName) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files[0]) {
      const file = files[0];
      const isPdf = file.type === 'application/pdf';

      setLocaltype(isPdf ? 'pdf' : 'image');
      setUploadImage(file);

      const blobUrl = URL.createObjectURL(file);
      setPreview(blobUrl);

      uploadDocumentInstant(file, typeCode, fieldName);
    }
  };

  const handlePartnerType = (e) => {
    reset();
    setPartnerType1(e.target.value);
    setPhotoPreview(photoDummy);
    setAadharFrontPreview(aadharFrontDummy);
    setAadharBackPreview(aadharBackDummy);
    setPanPreview(panCardDummy);
    setChequePreview(cancelChequeDummy);
    setGstPreview(gstRegistrationCertificate);
    setPanPreview1(panCardDummy);
    setChequePreview1(cancelChequeDummy);
    setIncorporationPreview(incorporationCertificate);
    setLogoPreview(logoDummy);
  };

  const getStateList = () => {
    const data = {
      countryId: 101
    };
    dispatch(getStateData(data));
  };

  const handleGetCity = useCallback(
    (optionVal) => {
      if (!optionVal) {
        dispatch(setCityData([]));
        setValue('districtId', null);
        return '';
      }
      const data = {
        stateId: optionVal,
        searchLiteral: ''
      };
      dispatch(getCityData(data));
    },
    [LoginData?.companyId, LoginData?.userId]
  );

  const safeSetPreview = (setter, url, dummy) => {
    if (!url || url.includes('/home/')) {
      setter(dummy);
    } else {
      setter(url);
    }
  };

  useEffect(() => {
    if (rowData) {
      setPartnerType1(rowData?.partnerType?.typeId);
      handleGetCity(rowData?.provinceId);

      setValue('partnerName', rowData?.partnerName ?? '');
      setValue('companyName', rowData?.companyName ?? rowData?.partnerName ?? '');
      setValue('fathersName', rowData?.fathersName ?? '');
      setValue('dob', rowData?.dob ?? '');
      setValue('dateOfIncorporation', rowData?.dateOfIncorporation ?? rowData?.dob ?? '');
      setValue('mobile', rowData?.mobile ?? '');
      setValue('emailAddress', rowData?.emailAddress ?? '');
      setValue('address', rowData?.address ?? '');
      setValue('provinceId', rowData?.provinceId ?? '');
      setValue('districtId', rowData?.districtId ?? '');
      setValue(
        'relationshipManager',
        rowData?.relationshipManagerId ?? rowData?.relationshipManager ?? ''
      );
      setValue('isNextUserAllowed', rowData?.isNextUserAllowed ?? false);
      setValue('isPartnerLoginAllowed', rowData?.isPartnerLoginAllowed ?? false);
      setValue('isGSTEnable', rowData?.isGSTEnable ?? false);
      setValue('gstNumber', rowData?.gstNumber ?? '');
      setValue('authorisedPersonName', rowData?.authorisedPersonName ?? '');
      setValue('partnerCompanyTypeId', rowData?.partnerCompanyTypeId ?? '');
      setValue('companyGstNumber', rowData?.companyGstNumber ?? '');
      setValue('companyPanNumber', rowData?.companyPanNumber ?? '');

      if (rowData?.partnerDocuments?.length > 0) {
        rowData?.partnerDocuments?.forEach((docItem) => {
          const dataTypeCode = docItem?.documentType?.typeCode;
          const isPdf = docItem?.documentUrl?.toLowerCase().endsWith('.pdf');
          const type = isPdf ? 'pdf' : 'image';

          if (dataTypeCode === 'CHEQUE') {
            setChequePreview1(docItem?.documentUrl);
            setChequePreview1type1(type);
          }
          if (dataTypeCode === 'PAN CARD') {
            setPanPreview1(docItem?.documentUrl);
            setPanPreview1type1(type);
          }
          if (dataTypeCode === 'GSTIN') {
            setGstPreview(docItem?.documentUrl);
            setGstPreviewtype1(type);
          }
          if (dataTypeCode === 'INCORPORATION_CERTIFICATE') {
            setIncorporationPreview(docItem?.documentUrl);
            setIncorporationPreviewtype1(type);
          }
          if (dataTypeCode === 'COMPANY_LOGO') {
            setLogoPreview(docItem?.documentUrl);
            setLogoPreviewtype1(type);
          }
          if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === false) {
            setAadharBackPreview(docItem?.documentUrl);
            setAadharBackPreviewtype1(type);
          }
          if (dataTypeCode === 'USER IMAGE') {
            safeSetPreview(setPhotoPreview, docItem?.documentUrl, photoDummy);
            setPhotoPreviewtype1(type);
          }
          if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === true) {
            setAadharFrontPreview(docItem?.documentUrl);
            setAadharFrontPreviewtype1(type);
          }
        });
      }
    }
  }, [rowData]);

  const onSubmit = useCallback(
    async (data) => {
      if (partnerType1 === 66) {
        if (!isValidValue(data?.dob)) {
          setError('dob', {
            type: 'manual',
            message: 'Date of Birth is required'
          });
          return;
        } else if (data?.dob) {
          const birthDate = new Date(data?.dob);
          const today = new Date();
          let age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          if (age < 18) {
            setError('dob', {
              type: 'manual',
              message: 'Age should be greater than 18 years'
            });
            return '';
          }
        }
      }

      const finalData = {
        companyId: LoginData?.companyId,
        typeId: partnerType1,
        partnerName: data?.partnerName || data?.companyName || '',
        companyName: data?.companyName ?? '',
        fathersName: data?.fathersName ?? '',
        mobile: data?.mobile ?? '',
        emailAddress: data?.emailAddress ?? '',
        dob: data?.dob ?? '',
        dateOfIncorporation: data?.dateOfIncorporation ?? '',
        companyGstNumber: data?.companyGstNumber ?? '',
        companyPanNumber: data?.companyPanNumber ?? '',
        partnerCompanyTypeId: data?.partnerCompanyTypeId ?? '',
        authorisedPersonName: data?.authorisedPersonName ?? '',
        address: data?.address ?? '',
        relationshipManagerId: data?.relationshipManager ?? null,
        isPartnerLoginAllowed: data?.isPartnerLoginAllowed ?? false,
        isNextUserAllowed: data?.isNextUserAllowed ?? false,
        isGSTEnable: data?.isGSTEnable ?? false,
        gstNumber: data?.isGSTEnable ? data?.gstNumber ?? '' : '',
        isSignUpFlow: true,
        partnerId: rowId,
        districtId: cityId
      };

      try {
        const res = await dispatch(saveApiData(OnboardingApi?.onboardUpdate, finalData));
        if (res?.status === 'success') {
          const PartnerId = res?.data?.partnerId;

          localStorage.setItem('partnerId', PartnerId);
          dispatch(setApiSuccess('Partner updated successfully'));
          navigate('/onboarding');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [
      LoginData,
      partnerType1,
      cityId,
      uploadPhoto,
      uploadImageFileFront,
      uploadImageFileBack,
      uploadPanImage,
      uploadChequeImage,
      logoUpload,
      gstImage,
      incorporationUploadComp,
      uploadPanImageCompany,
      uploadChequeCompany
    ]
  );

  const uploadDocumentInstant = async (file, typeCode, fieldName) => {
    if (!file || file.size <= 0) return;

    try {
      const formData = new FormData();
      formData.append('partnerId', reviewData?.partnerId);
      formData.append('companyId', reviewData?.companyId);

      const docType = DocsTypesDrop.find((d) => d.typeCode === typeCode);
      if (docType) formData.append('documentTypeId', docType.value);

      formData.append(fieldName, file);

      const res = await dispatch(savefileApiData(OnboardingApi?.onboardDocUpload, formData));
      if (res?.success === true) {
        dispatch(setApiSuccess(res?.msg || 'upload successfully'));
        dispatch(
          getOnboardingView({
            companyId: reviewData?.companyId,
            partnerId: reviewData?.partnerId
          })
        );
      }
    } catch (err) {
      console.error(`Instant upload error (${typeCode})`, err);
    }
  };

  async function handlePreviewDoc(partnerDocumentId) {
    const { partnerId, companyId } = reviewData;

    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    const timestamp = new Date().getTime();

    const blob = await dispatch(
      PreviewImageApi(
        `pdoc/${companyId}/${partnerId}/${partnerDocumentId}?t=${timestamp}`,
        null,
        true
      )
    );

    if (!blob) return;

    setPreviewFileType(blob.type === 'application/pdf' ? 'pdf' : 'image');
    const fileURL = URL.createObjectURL(blob);
    setPreviewUrl(fileURL);
    setOpenPreview(true);
  }

  useEffect(() => {
    if (!rowData && reviewData && String(reviewData?.partnerId) === String(rowId)) {
      const companyId = reviewData?.companyId;
      const typeId = reviewData?.typeId;
      setPartnerType1(typeId);

      const resetData = {
        partnerName: reviewData?.partnerName || '',
        fathersName: reviewData?.fathersName || '',
        dob: reviewData?.dob || '',
        mobile: reviewData?.mobile || '',
        emailAddress: reviewData?.emailAddress || '',
        address: reviewData?.address || '',
        companyName: reviewData?.partnerName || '',
        authorisedPersonName: reviewData?.authorisedPersonName || '',
        partnerCompanyTypeId: reviewData?.partnerCompanyTypeId || '',
        dateOfIncorporation: reviewData?.dateOfIncorporation || '',
        companyGstNumber: reviewData?.companyGstNumber || '',
        companyPanNumber: reviewData?.companyPanNumber || '',
        relationshipManager: reviewData?.relationshipManager || null,
        isNextUserAllowed: reviewData?.isNextUserAllowed ?? false,
        isPartnerLoginAllowed: reviewData?.isPartnerLoginAllowed ?? false,
        isGSTEnable: reviewData?.isGSTEnable ?? false,
        gstNumber: reviewData?.gstNumber || ''
      };

      if (reviewData?.provinceId) {
        resetData.provinceId = reviewData?.provinceId;
        const data = {
          stateId: reviewData?.provinceId,
          searchLiteral: ''
        };
        dispatch(getCityData(data));
      }

      if (reviewData?.districtId) {
        resetData.districtId = reviewData?.districtId;
      }

      reset(resetData);
    }
  }, [reviewData, rowData, rowId, reset, dispatch]);

  useEffect(() => {
    dispatch(getPartnerTypesData());
    dispatch(getPartnerCompanyType());
    dispatch(getDocsTypesData());
    getStateList();
  }, []);

  useEffect(() => {
    const list = ReportingManagerListData || [];
    const selected = list.find((u) => String(u.userId) === String(relationshipManager));
    const name = selected ? selected.fullName || selected.email || '' : '';
    sessionStorage.setItem('relationshipManagerSelected', name);
  }, [relationshipManager, ReportingManagerListData]);

  const getReportingManagerListApi = useCallback(() => {
    if (!LoginData || !cityId) return;
    const credentials = {
      cityId: cityId
    };
    dispatch(getReportingManagerList(credentials));
  }, [LoginData, cityId, dispatch]);

  useEffect(() => {
    getReportingManagerListApi();
  }, [getReportingManagerListApi]);

  useEffect(() => {
    const credential = {
      companyId: LoginData?.companyId || '',
      partnerId: rowId
    };
    dispatch(getOnboardingView(credential));
  }, []);

  useEffect(() => {
    if (reviewData?.partnerDocuments?.length > 0) {
      reviewData.partnerDocuments.forEach(async (docItem) => {
        if (docItem?.documentUrl) {
          const dataTypeCode = docItem?.documentType?.typeCode;
          const endpoint = docItem.documentUrl.startsWith('/')
            ? docItem.documentUrl.substring(1)
            : docItem.documentUrl;
          const blob = await dispatch(PreviewImageApi(endpoint, null, true));
          if (blob) {
            const objectUrl = URL.createObjectURL(blob);
            if (dataTypeCode === 'USER IMAGE') setPhotoPreview(objectUrl);
            if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === true)
              setAadharFrontPreview(objectUrl);
            if (dataTypeCode === 'AADHAR CARD' && docItem?.aadharFrontFace === false)
              setAadharBackPreview(objectUrl);
            if (dataTypeCode === 'PAN CARD') {
              setPanPreview(objectUrl);
              setPanPreview1(objectUrl);
            }
            if (dataTypeCode === 'CHEQUE') {
              setChequePreview(objectUrl);
              setChequePreview1(objectUrl);
            }
            if (dataTypeCode === 'GSTIN') setGstPreview(objectUrl);
            if (dataTypeCode === 'INCORPORATION_CERTIFICATE') setIncorporationPreview(objectUrl);
            if (dataTypeCode === 'COMPANY_LOGO') setLogoPreview(objectUrl);
          }
        }
      });
    }
  }, [reviewData, dispatch]);

  useEffect(() => {
    if (isEditBlocked) {
      navigate(location.pathname.startsWith('/partners') ? '/partners' : '/onboarding', {
        replace: true
      });
    }
  }, [isEditBlocked, location.pathname, navigate]);

  if (isEditBlocked) return null;

  return (
    <Page title="Kpros by Kalolytic Solutions || On Boarding">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
            sx={{ mb: 3 }}
          >
            <PageTitle
              info={
                parent === 'partner' ? 'Partner View' : rowId ? 'Edit Partner' : 'Add New Partner'
              }
            />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          {/* === Tabs === */}
          {parent === 'on-boarding' ? (
            <Tabs
              value={fileTypeId}
              onChange={handleChange}
              aria-label="onboarding tabs"
              sx={{ ...pillTabsSx, mb: 3 }}
            >
              <Tab
                icon={<HandshakeIcon />}
                iconPosition="start"
                label="Partner Details"
                value={0}
              />
            </Tabs>
          ) : null}

          {fileTypeId === 0 && (
            <>
              {/* Partner Type Selection Card */}
              <Card
                sx={{
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                  p: 3,
                  mb: 3
                }}
              >
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#475569', mb: 1 }}>
                      Partner Type <span style={{ color: '#ef4444' }}>*</span>
                    </Typography>
                    <Select
                      fullWidth
                      size="small"
                      sx={{
                        borderRadius: '8px',
                        bgcolor: '#fff',
                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' }
                      }}
                      value={partnerType1}
                      onChange={(e) => {
                        handlePartnerType(e);
                      }}
                    >
                      {PartnerStatusDrop?.length > 0 &&
                        PartnerStatusDrop?.map((item) => (
                          <MenuItem value={item?.value} key={item?.value}>
                            {item?.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Grid>
                </Grid>
              </Card>

              <form id="myEditOnboardingForm" onSubmit={handleReduxSubmit(onSubmit)}>
                {partnerType1 &&
                  (partnerType1 === 66 ? (
                    <>
                      {/* Individual Details */}
                      <Card
                        sx={{
                          borderRadius: '16px',
                          border: '1px solid #e2e8f0',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                          p: 3.5,
                          mb: 3
                        }}
                      >
                        <Typography
                          sx={{ fontSize: 16, fontWeight: 700, color: '#13519d', mb: 2.5 }}
                        >
                          Individual Details
                        </Typography>
                        <Grid container spacing={2.5}>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="partnerName"
                              label="Full Name"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="NAME"
                              fieldType="ALPHABET"
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="fathersName"
                              label="Father Name"
                              control={control}
                              errors={errors}
                              isRequired
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomDate
                              name="dob"
                              label="Date of Birth"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="DATE"
                              fieldType="DATE_FIELD"
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="mobile"
                              label="Mobile"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="MOBILE"
                              type="Number"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="emailAddress"
                              label="Email"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="EMAIL"
                              fieldType="TEXT_FIELD"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="address"
                              label="Address"
                              control={control}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="provinceId"
                              label="State"
                              control={control}
                              errors={errors}
                              options={stateDrop || []}
                              onChange={(event, val) => {
                                handleGetCity(val);
                              }}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="districtId"
                              label="City"
                              control={control}
                              errors={errors}
                              options={CityDrop || []}
                              disabled={!stateSelected || parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="relationshipManager"
                              label="Relationship manager"
                              control={control}
                              errors={errors}
                              options={
                                ReportingManagerListData.map((user) => ({
                                  value: user.userId,
                                  label: user.fullName
                                })) || []
                              }
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="isNextUserAllowed"
                              label="Next User Allowed"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="isPartnerLoginAllowed"
                              label="Reco Engine Access"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="isGSTEnable"
                              label="Is GST Enable"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                          {isGSTEnable && (
                            <Grid item xs={12} sm={6} md={4}>
                              <CustomInput
                                name="gstNumber"
                                label="GST Number"
                                control={control}
                                errors={errors}
                                isRequired
                                fieldCode="GSTIN"
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Card>

                      {/* Upload Documents */}
                      <Card
                        sx={{
                          borderRadius: '16px',
                          border: '1px solid #e2e8f0',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                          p: 3.5,
                          mb: 3
                        }}
                      >
                        <Typography
                          sx={{ fontSize: 16, fontWeight: 700, color: '#13519d', mb: 2.5 }}
                        >
                          Upload Documents
                        </Typography>
                        <Grid container spacing={3}>
                          {/* Photo */}
                          {(() => {
                            const photoDoc = reviewData?.partnerDocuments?.find(
                              (doc) => doc?.documentType?.typeCode === 'USER IMAGE'
                            );
                            return (
                              <Grid item xs={12} sm={6} md={3}>
                                <Box
                                  sx={{
                                    p: 2,
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    bgcolor: '#f8fafc',
                                    textAlign: 'center'
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 1.5
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      sx={{ fontWeight: 700, color: '#1e293b' }}
                                    >
                                      Photo
                                    </Typography>
                                    {photoDoc && (
                                      <Tooltip title="Preview Document" arrow>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            color: '#13519d',
                                            bgcolor: '#e0f2fe',
                                            '&:hover': { bgcolor: '#bae6fd' },
                                            p: 0.5
                                          }}
                                          onClick={() =>
                                            handlePreviewDoc(photoDoc?.partnerDocumentId)
                                          }
                                        >
                                          <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    id="contained-button-file1"
                                    disabled={parent === 'partner'}
                                    multiple
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setPhotoPreview,
                                        setUploadPhoto,
                                        setPhotoPreviewtype1,
                                        'USER IMAGE',
                                        'userImage'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file1"
                                    style={{
                                      cursor: parent === 'partner' ? 'default' : 'pointer',
                                      display: 'block'
                                    }}
                                  >
                                    <Box
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setPhotoPreview,
                                          setUploadPhoto,
                                          setPhotoPreviewtype1,
                                          'USER IMAGE',
                                          'userImage'
                                        )
                                      }
                                      sx={{
                                        height: 180,
                                        borderRadius: '10px',
                                        border: '1.5px dashed #cbd5e1',
                                        bgcolor: '#fff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                          borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                          bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                        }
                                      }}
                                    >
                                      <img
                                        src={photoPreview}
                                        alt="Person"
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'contain'
                                        }}
                                      />
                                    </Box>
                                  </label>
                                  {photoDoc && (
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Uploaded"
                                      size="small"
                                      sx={{
                                        mt: 1.5,
                                        bgcolor: 'rgba(22, 163, 74, 0.1)',
                                        color: '#16a34a',
                                        fontWeight: 600,
                                        border: '1px solid rgba(22, 163, 74, 0.2)'
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}

                          {/* Aadhar Front */}
                          {(() => {
                            const aadharFrontDoc = reviewData?.partnerDocuments?.find(
                              (doc) =>
                                doc?.documentType?.typeCode === 'AADHAR CARD' &&
                                doc?.aadharFrontFace === true
                            );
                            return (
                              <Grid item xs={12} sm={6} md={3}>
                                <Box
                                  sx={{
                                    p: 2,
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    bgcolor: '#f8fafc',
                                    textAlign: 'center'
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 1.5
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      sx={{ fontWeight: 700, color: '#1e293b' }}
                                    >
                                      Aadhar Card
                                    </Typography>
                                    {aadharFrontDoc && (
                                      <Tooltip title="Preview Document" arrow>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            color: '#13519d',
                                            bgcolor: '#e0f2fe',
                                            '&:hover': { bgcolor: '#bae6fd' },
                                            p: 0.5
                                          }}
                                          onClick={() =>
                                            handlePreviewDoc(aadharFrontDoc?.partnerDocumentId)
                                          }
                                        >
                                          <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    id="contained-button-file2"
                                    disabled={parent === 'partner'}
                                    multiple
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setAadharFrontPreview,
                                        setUploadImageFileFront,
                                        setAadharFrontPreviewtype1,
                                        'AADHAR CARD',
                                        'aadharFront'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file2"
                                    style={{
                                      cursor: parent === 'partner' ? 'default' : 'pointer',
                                      display: 'block'
                                    }}
                                  >
                                    <Box
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setAadharFrontPreview,
                                          setUploadImageFileFront,
                                          setAadharFrontPreviewtype1,
                                          'AADHAR CARD',
                                          'aadharFront'
                                        )
                                      }
                                      sx={{
                                        height: 180,
                                        borderRadius: '10px',
                                        border: '1.5px dashed #cbd5e1',
                                        bgcolor: '#fff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                          borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                          bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                        }
                                      }}
                                    >
                                      {aadharFrontPreviewtype1 === 'pdf' ? (
                                        <Document
                                          file={aadharFrontPreview}
                                          onLoadSuccess={(numPages) =>
                                            onDocumentLoadSuccess(numPages)
                                          }
                                        >
                                          <Pages
                                            pageNumber={pageNumber}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                          />
                                        </Document>
                                      ) : (
                                        <img
                                          src={aadharFrontPreview}
                                          alt="Aadhar Front"
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain'
                                          }}
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {aadharFrontDoc && (
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Verified Document"
                                      size="small"
                                      sx={{
                                        mt: 1.5,
                                        bgcolor: 'rgba(22, 163, 74, 0.1)',
                                        color: '#16a34a',
                                        fontWeight: 600,
                                        border: '1px solid rgba(22, 163, 74, 0.2)'
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}

                          {/* PAN Card */}
                          {(() => {
                            const panDoc = reviewData?.partnerDocuments?.find(
                              (doc) => doc?.documentType?.typeCode === 'PAN CARD'
                            );
                            return (
                              <Grid item xs={12} sm={6} md={3}>
                                <Box
                                  sx={{
                                    p: 2,
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    bgcolor: '#f8fafc',
                                    textAlign: 'center'
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 1.5
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      sx={{ fontWeight: 700, color: '#1e293b' }}
                                    >
                                      PAN Card
                                    </Typography>
                                    {panDoc && (
                                      <Tooltip title="Preview Document" arrow>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            color: '#13519d',
                                            bgcolor: '#e0f2fe',
                                            '&:hover': { bgcolor: '#bae6fd' },
                                            p: 0.5
                                          }}
                                          onClick={() =>
                                            handlePreviewDoc(panDoc?.partnerDocumentId)
                                          }
                                        >
                                          <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    id="contained-button-file4"
                                    disabled={parent === 'partner'}
                                    multiple
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setPanPreview,
                                        setUploadPanImage,
                                        setPanPreviewtype1,
                                        'PAN CARD',
                                        'panCard'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file4"
                                    style={{
                                      cursor: parent === 'partner' ? 'default' : 'pointer',
                                      display: 'block'
                                    }}
                                  >
                                    <Box
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setPanPreview,
                                          setUploadPanImage,
                                          setPanPreviewtype1
                                        )
                                      }
                                      sx={{
                                        height: 180,
                                        borderRadius: '10px',
                                        border: '1.5px dashed #cbd5e1',
                                        bgcolor: '#fff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                          borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                          bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                        }
                                      }}
                                    >
                                      {panPreviewtype1 === 'pdf' ? (
                                        <Document
                                          file={panPreview}
                                          onLoadSuccess={(numPages) =>
                                            onDocumentLoadSuccess(numPages)
                                          }
                                        >
                                          <Pages
                                            pageNumber={pageNumber}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                          />
                                        </Document>
                                      ) : (
                                        <img
                                          src={panPreview}
                                          alt="Pan Card"
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain'
                                          }}
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {panDoc && (
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Verified Document"
                                      size="small"
                                      sx={{
                                        mt: 1.5,
                                        bgcolor: 'rgba(22, 163, 74, 0.1)',
                                        color: '#16a34a',
                                        fontWeight: 600,
                                        border: '1px solid rgba(22, 163, 74, 0.2)'
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}

                          {/* Cancelled Cheque */}
                          {(() => {
                            const chequeDoc = reviewData?.partnerDocuments?.find(
                              (doc) => doc?.documentType?.typeCode === 'CHEQUE'
                            );
                            return (
                              <Grid item xs={12} sm={6} md={3}>
                                <Box
                                  sx={{
                                    p: 2,
                                    borderRadius: '12px',
                                    border: '1px solid #e2e8f0',
                                    bgcolor: '#f8fafc',
                                    textAlign: 'center'
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 1.5
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      sx={{ fontWeight: 700, color: '#1e293b' }}
                                    >
                                      Cancelled Cheque
                                    </Typography>
                                    {chequeDoc && (
                                      <Tooltip title="Preview Document" arrow>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            color: '#13519d',
                                            bgcolor: '#e0f2fe',
                                            '&:hover': { bgcolor: '#bae6fd' },
                                            p: 0.5
                                          }}
                                          onClick={() =>
                                            handlePreviewDoc(chequeDoc?.partnerDocumentId)
                                          }
                                        >
                                          <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                  <input
                                    accept="image/png, image/gif, image/jpeg, application/pdf"
                                    id="contained-button-file5"
                                    disabled={parent === 'partner'}
                                    multiple
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setChequePreview,
                                        setUploadChequeImage,
                                        setChequePreviewtype1,
                                        'CHEQUE',
                                        'cheque'
                                      )
                                    }
                                  />
                                  <label
                                    htmlFor="contained-button-file5"
                                    style={{
                                      cursor: parent === 'partner' ? 'default' : 'pointer',
                                      display: 'block'
                                    }}
                                  >
                                    <Box
                                      onDragOver={dragOver}
                                      onDragEnter={dragEnter}
                                      onDragLeave={dragLeave}
                                      onDrop={(e) =>
                                        fileDrop(
                                          e,
                                          setChequePreview,
                                          setUploadChequeImage,
                                          setChequePreviewtype1
                                        )
                                      }
                                      sx={{
                                        height: 180,
                                        borderRadius: '10px',
                                        border: '1.5px dashed #cbd5e1',
                                        bgcolor: '#fff',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                          borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                          bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                        }
                                      }}
                                    >
                                      {chequePreviewtype1 === 'pdf' ? (
                                        <Document
                                          file={chequePreview}
                                          onLoadSuccess={(numPages) =>
                                            onDocumentLoadSuccess(numPages)
                                          }
                                        >
                                          <Pages
                                            pageNumber={pageNumber}
                                            renderTextLayer={false}
                                            renderAnnotationLayer={false}
                                          />
                                        </Document>
                                      ) : (
                                        <img
                                          src={chequePreview}
                                          alt="Cancel Cheque"
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain'
                                          }}
                                        />
                                      )}
                                    </Box>
                                  </label>
                                  {chequeDoc && (
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Verified Document"
                                      size="small"
                                      sx={{
                                        mt: 1.5,
                                        bgcolor: 'rgba(22, 163, 74, 0.1)',
                                        color: '#16a34a',
                                        fontWeight: 600,
                                        border: '1px solid rgba(22, 163, 74, 0.2)'
                                      }}
                                    />
                                  )}
                                </Box>
                              </Grid>
                            );
                          })()}
                        </Grid>
                      </Card>
                    </>
                  ) : (
                    <>
                      {/* Company Details */}
                      <Card
                        sx={{
                          borderRadius: '16px',
                          border: '1px solid #e2e8f0',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                          p: 3.5,
                          mb: 3
                        }}
                      >
                        <Typography
                          sx={{ fontSize: 16, fontWeight: 700, color: '#13519d', mb: 2.5 }}
                        >
                          Company Details
                        </Typography>
                        <Grid container spacing={2.5}>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="companyName"
                              label="Company Name"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="NAME"
                              fieldType="ALPHABET"
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="authorisedPersonName"
                              label="Authorised Person Name"
                              control={control}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="mobile"
                              label="Mobile Number"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="MOBILE"
                              fieldType="NUMBER_FIELD"
                              type="Number"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="emailAddress"
                              label="Email"
                              control={control}
                              errors={errors}
                              isRequired
                              fieldCode="EMAIL"
                              fieldType="TEXT_FIELD"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="partnerCompanyTypeId"
                              label="Company Type"
                              control={control}
                              errors={errors}
                              options={PartnerCompanyTypesDrop || []}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomDate
                              name="dateOfIncorporation"
                              label="Date of Incorporation"
                              control={control}
                              fieldCode="DATE"
                              fieldType="DATE_FIELD"
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="companyGstNumber"
                              label="GST Number"
                              control={control}
                              errors={errors}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="companyPanNumber"
                              label="PAN Number"
                              control={control}
                              errors={errors}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomInput
                              name="address"
                              label="Address"
                              control={control}
                              errors={errors}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="provinceId"
                              label="State"
                              control={control}
                              errors={errors}
                              options={stateDrop || []}
                              onChange={(event, val) => {
                                handleGetCity(val);
                              }}
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="districtId"
                              label="City"
                              control={control}
                              errors={errors}
                              options={CityDrop || []}
                              disabled={!stateSelected || parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="relationshipManager"
                              label="Relationship manager"
                              control={control}
                              errors={errors}
                              options={
                                ReportingManagerListData.map((user) => ({
                                  value: user.userId,
                                  label: user.fullName
                                })) || []
                              }
                              disabled={parent === 'partner'}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="isNextUserAllowed"
                              label="Next User Allowed"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4}>
                            <CustomSelect
                              name="isPartnerLoginAllowed"
                              label="Partner Login Allowed"
                              control={control}
                              errors={errors}
                              options={[
                                { value: true, label: 'Yes' },
                                { value: false, label: 'No' }
                              ]}
                            />
                          </Grid>
                        </Grid>
                      </Card>

                      {/* Company Documents */}
                      <Card
                        sx={{
                          borderRadius: '16px',
                          border: '1px solid #e2e8f0',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                          p: 3.5,
                          mb: 3
                        }}
                      >
                        <Typography
                          sx={{ fontSize: 16, fontWeight: 700, color: '#13519d', mb: 2.5 }}
                        >
                          Upload Documents
                        </Typography>
                        <Grid container spacing={3}>
                          {/* GST Certificate */}
                          <Grid item xs={12} sm={6} md={4}>
                            <Box
                              sx={{
                                p: 2,
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0',
                                bgcolor: '#f8fafc',
                                textAlign: 'center'
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                              >
                                GST Certificate
                              </Typography>
                              <input
                                accept="image/png, image/gif, image/jpeg, application/pdf"
                                id="contained-button-file7"
                                disabled={parent === 'partner'}
                                multiple
                                type="file"
                                style={{ display: 'none' }}
                                onChange={(e) =>
                                  handleFileUpload(
                                    e,
                                    setGstPreview,
                                    setGstImage,
                                    setGstPreviewtype1,
                                    'GSTIN',
                                    'gstInDocument'
                                  )
                                }
                              />
                              <label
                                htmlFor="contained-button-file7"
                                style={{
                                  cursor: parent === 'partner' ? 'default' : 'pointer',
                                  display: 'block'
                                }}
                              >
                                <Box
                                  onDragOver={dragOver}
                                  onDragEnter={dragEnter}
                                  onDragLeave={dragLeave}
                                  onDrop={(e) =>
                                    fileDrop(
                                      e,
                                      setGstPreview,
                                      setGstImage,
                                      setGstPreviewtype1,
                                      'GSTIN',
                                      'gstInDocument'
                                    )
                                  }
                                  sx={{
                                    height: 180,
                                    borderRadius: '10px',
                                    border: '1.5px dashed #cbd5e1',
                                    bgcolor: '#fff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                      borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                      bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                    }
                                  }}
                                >
                                  {gstPreviewtype1 === 'pdf' ? (
                                    <Document
                                      file={gstPreview}
                                      onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                    >
                                      <Pages
                                        pageNumber={pageNumber}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    </Document>
                                  ) : (
                                    <img
                                      src={gstPreview}
                                      alt="GST Certificate"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                      }}
                                    />
                                  )}
                                </Box>
                              </label>
                            </Box>
                          </Grid>

                          {/* PAN Card */}
                          <Grid item xs={12} sm={6} md={4}>
                            <Box
                              sx={{
                                p: 2,
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0',
                                bgcolor: '#f8fafc',
                                textAlign: 'center'
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                              >
                                PAN Card
                              </Typography>
                              <input
                                accept="image/png, image/gif, image/jpeg, application/pdf"
                                id="contained-button-file9"
                                disabled={parent === 'partner'}
                                multiple
                                type="file"
                                style={{ display: 'none' }}
                                onChange={(e) =>
                                  handleFileUpload(
                                    e,
                                    setPanPreview1,
                                    setUploadPanImageCompany,
                                    setPanPreview1type1,
                                    'PAN CARD',
                                    'panCard'
                                  )
                                }
                              />
                              <label
                                htmlFor="contained-button-file9"
                                style={{
                                  cursor: parent === 'partner' ? 'default' : 'pointer',
                                  display: 'block'
                                }}
                              >
                                <Box
                                  onDragOver={dragOver}
                                  onDragEnter={dragEnter}
                                  onDragLeave={dragLeave}
                                  onDrop={(e) =>
                                    fileDrop(
                                      e,
                                      setPanPreview1,
                                      setUploadPanImageCompany,
                                      setPanPreview1type1,
                                      'PAN CARD',
                                      'panCard'
                                    )
                                  }
                                  sx={{
                                    height: 180,
                                    borderRadius: '10px',
                                    border: '1.5px dashed #cbd5e1',
                                    bgcolor: '#fff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                      borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                      bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                    }
                                  }}
                                >
                                  {panPreview1type1 === 'pdf' ? (
                                    <Document
                                      file={panPreview1}
                                      onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                    >
                                      <Pages
                                        pageNumber={pageNumber}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    </Document>
                                  ) : (
                                    <img
                                      src={panPreview1}
                                      alt="Pan Card"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                      }}
                                    />
                                  )}
                                </Box>
                              </label>
                            </Box>
                          </Grid>

                          {/* Cancelled Cheque */}
                          <Grid item xs={12} sm={6} md={4}>
                            <Box
                              sx={{
                                p: 2,
                                borderRadius: '12px',
                                border: '1px solid #e2e8f0',
                                bgcolor: '#f8fafc',
                                textAlign: 'center'
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 700, color: '#1e293b', mb: 1.5 }}
                              >
                                Cancelled Cheque
                              </Typography>
                              <input
                                accept="image/png, image/gif, image/jpeg, application/pdf"
                                id="contained-button-file10"
                                disabled={parent === 'partner'}
                                multiple
                                type="file"
                                style={{ display: 'none' }}
                                onChange={(e) =>
                                  handleFileUpload(
                                    e,
                                    setChequePreview1,
                                    setUploadChequeCompany,
                                    setChequePreview1type1,
                                    'CHEQUE',
                                    'cheque'
                                  )
                                }
                              />
                              <label
                                htmlFor="contained-button-file10"
                                style={{
                                  cursor: parent === 'partner' ? 'default' : 'pointer',
                                  display: 'block'
                                }}
                              >
                                <Box
                                  onDragOver={dragOver}
                                  onDragEnter={dragEnter}
                                  onDragLeave={dragLeave}
                                  onDrop={(e) =>
                                    fileDrop(
                                      e,
                                      setChequePreview1,
                                      setUploadChequeCompany,
                                      setChequePreview1type1,
                                      'CHEQUE',
                                      'cheque'
                                    )
                                  }
                                  sx={{
                                    height: 180,
                                    borderRadius: '10px',
                                    border: '1.5px dashed #cbd5e1',
                                    bgcolor: '#fff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    position: 'relative',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                      borderColor: parent === 'partner' ? '#cbd5e1' : '#13519d',
                                      bgcolor: parent === 'partner' ? '#fff' : '#f0f7ff'
                                    }
                                  }}
                                >
                                  {chequePreview1type1 === 'pdf' ? (
                                    <Document
                                      file={chequePreview1}
                                      onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                    >
                                      <Pages
                                        pageNumber={pageNumber}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    </Document>
                                  ) : (
                                    <img
                                      src={chequePreview1}
                                      alt="Cancel Cheque"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                      }}
                                    />
                                  )}
                                </Box>
                              </label>
                            </Box>
                          </Grid>
                        </Grid>
                      </Card>
                    </>
                  ))}
              </form>

              {/* Action Button */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, mb: 4 }}>
                {parent !== 'partner' && (
                  <Button
                    type="submit"
                    form="myEditOnboardingForm"
                    variant="contained"
                    sx={{
                      bgcolor: '#13519d',
                      color: '#fff',
                      px: 4,
                      py: 1.2,
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: 600,
                      textTransform: 'none',
                      boxShadow: '0 4px 12px rgba(19, 81, 157, 0.25)',
                      '&:hover': { bgcolor: '#0d3d75' }
                    }}
                  >
                    Save Changes
                  </Button>
                )}
              </Box>
            </>
          )}
          {fileTypeId === 1 && <PartnerHierarchyPage partnerId={rowId} />}
        </Box>

        {/* Document Preview Dialog */}
        <Dialog
          open={openPreview}
          onClose={() => setOpenPreview(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              bgcolor: '#f8fafc',
              borderBottom: '1px solid #e2e8f0',
              fontWeight: 700,
              fontSize: 16,
              color: '#1e293b',
              py: 2,
              px: 3
            }}
          >
            Document Preview
            <IconButton
              size="small"
              onClick={() => setOpenPreview(false)}
              sx={{ color: '#64748b' }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 3 }}>
            {previewUrl && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  bgcolor: '#f8fafc',
                  p: 2,
                  borderRadius: '12px',
                  border: '1px solid #e2e8f0'
                }}
              >
                {previewFileType === 'pdf' ? (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      overflow: 'auto',
                      maxHeight: '70vh'
                    }}
                  >
                    <Document
                      file={previewUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<div>Loading PDF...</div>}
                    >
                      <Pages
                        pageNumber={pageNumber}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                    </Document>
                  </Box>
                ) : (
                  <Box
                    component="img"
                    src={previewUrl}
                    alt="Preview"
                    sx={{
                      width: '100%',
                      maxHeight: 500,
                      objectFit: 'contain'
                    }}
                  />
                )}
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ p: 2.5, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
            <Button
              variant="outlined"
              onClick={() => setOpenPreview(false)}
              sx={{
                borderRadius: '8px',
                borderColor: '#cbd5e1',
                color: '#475569',
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': { borderColor: '#94a3b8', bgcolor: '#f1f5f9' }
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
export default EditOnBoarding;
